const latestUpdatesBlocks = document.querySelectorAll('.latest-updates');

latestUpdatesBlocks.forEach(function (block) {
    const filterBtns = block.querySelectorAll('.filter-btn');
    const cards = block.querySelectorAll('.update-card');

    if (!filterBtns.length || !cards.length) {
        return;
    }

    filterBtns.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const filterValue = this.getAttribute('data-filter');

            filterBtns.forEach(function (btn) {
                btn.classList.remove('active');
            });
            this.classList.add('active');

            cards.forEach(function (card) {
                const cardCategories = (card.getAttribute('data-categories') || '').split(',');
                if (filterValue === 'all' || cardCategories.includes(filterValue)) {
                    card.classList.remove('hidden');
                } else {
                    card.classList.add('hidden');
                }
            });
        });
    });
});
